const GET_MAIL_TEMPLATES = "mail_templates";

const MAIL_TEMPLATES = "mail_templates/";

const MULTI_DELET = "mail_template_sents/remove/bulk_delete";

export default { GET_MAIL_TEMPLATES, MAIL_TEMPLATES, MULTI_DELET };
